import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { PagosFormularioComponent } from './formulario/formulario.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'servicio-financiero/pago-publico',
    children: [
       { path: 'lista', component: ListaComponent},
       { path: 'nuevo', component: PagosFormularioComponent },
       { path: 'editar/:id', component: PagosFormularioComponent},
    ],
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PagosPublicosRoutingModule { }

